import { Box, Circle, Image, Text } from "@chakra-ui/react";

export default function IndividualCard({ image, name, id, joined, completed, in_progress }) {
    return (
        <Box
            d='flex'
            width='100%'
            justifyContent='flex-start'
            py='1rem'
            borderBottom='1px solid rgba(0, 0, 0, 0.05)'
        >
            <Circle
                size='50px'
                objectFit='cover'
                mr='1rem'
            >
                {
                    image ?
                        <Image src={image} alt={name} borderRadius='50%' width='50px' height='50px' fallbackSrc='https://source.unsplash.com/random/800x600' objectFit='cover' /> :
                        <Circle
                            fontSize='16px'
                            color='#222222'
                            fontWeight='600'
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            bg=' rgba(245, 106, 121, 0.2)'
                            size='40px'
                        >
                            {id + 1}
                        </Circle>
                }
            </Circle>
            <Box
                d='flex'
                flexDir='column'
                w='100%'
            >
                <Text
                    fontSize='14px'
                    color='#333333'
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                >
                    {name}
                </Text>
                <Box
                    d='flex'
                    w='100%'
                    justifyContent='space-between'
                    alignItems='center'
                >
                    <Text
                        fontSize='14px'
                        color='#222222'
                        fontWeight='600'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        {joined} <span style={{ fontFamily: 'Mulish, sans-serif', color: '#666666', fontSize: '10px', fontWeight: '400' }}>Joined</span>
                    </Text>
                    <Text
                        fontSize='14px'
                        color='#222222'
                        fontWeight='600'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        {completed} <span style={{ fontFamily: 'Mulish, sans-serif', color: '#666666', fontSize: '10px', fontWeight: '400' }}>Completed</span>
                    </Text>
                    <Text
                        fontSize='14px'
                        color='#222222'
                        fontWeight='600'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        {in_progress} <span style={{ fontFamily: 'Mulish, sans-serif', color: '#666666', fontSize: '10px', fontWeight: '400' }}>In Progress</span>
                    </Text>
                </Box>
            </Box>
        </Box>
    )
}